
export interface RateioItemInput {
  itemPrice: number | null | undefined;
  sellingPrice: number | null | undefined;
}

export interface RateioItemResult {
  sellingPrice: number | null;
  rateado: boolean;
  semItemPrice: boolean;
}

const round2 = (value: number): number => Math.round((value + Number.EPSILON) * 100) / 100;

export function rateioSellingPrice(
  total: number,
  itens: RateioItemInput[],
): RateioItemResult[] {
  const fixadosSum = itens.reduce(
    (acc, item) => (item.sellingPrice != null ? acc + Number(item.sellingPrice) : acc),
    0,
  );

  const livresIndexes = itens
    .map((item, index) => ({ item, index }))
    .filter(
      ({ item }) =>
        item.sellingPrice == null && item.itemPrice != null && Number(item.itemPrice) > 0,
    )
    .map(({ index }) => index);

  const resultados: RateioItemResult[] = itens.map((item) => ({
    sellingPrice: item.sellingPrice ?? null,
    rateado: false,
    semItemPrice: item.sellingPrice == null && !(item.itemPrice != null && Number(item.itemPrice) > 0),
  }));

  if (livresIndexes.length === 0) {
    return resultados;
  }

  const somaItemPriceLivres = livresIndexes.reduce(
    (acc, idx) => acc + Number(itens[idx].itemPrice),
    0,
  );

  if (somaItemPriceLivres <= 0) {
    return resultados;
  }

  const restante = round2(total - fixadosSum);

  let acumulado = 0;
  livresIndexes.forEach((idx, posicao) => {
    const isUltimo = posicao === livresIndexes.length - 1;
    const itemPrice = Number(itens[idx].itemPrice);
    const valor = isUltimo ? round2(restante - acumulado) : round2((restante * itemPrice) / somaItemPriceLivres);
    acumulado = round2(acumulado + valor);
    resultados[idx] = { sellingPrice: valor, rateado: true, semItemPrice: false };
  });

  return resultados;
}
